const isString = (val) => typeof val === "string";
const toString = (value) => {
  if (typeof value === "number" && (!isFinite(value) || isNaN(value))) {
    return "";
  }
  if (typeof value !== "string" && typeof value !== "number") {
    return "";
  }
  return String(value);
};
export {
  isString,
  toString
};
